import { addDays, differenceInDays } from './dateFormatter'

interface IAccessDays {
  expireDate: string
  availableUntil?: string
  availableTimeLength?: number
  activatedAt: string
}

export function getAccessDays({
  availableUntil,
  expireDate,
  availableTimeLength,
  activatedAt,
}: IAccessDays) {
  // Prioridade 1: Data específica da matrícula (availableUntil)
  if (availableUntil) {
    return {
      days: differenceInDays(new Date().toDateString(), availableUntil),
      expireDate: availableUntil,
    }
  }

  // Prioridade 2: Tempo de acesso específico da matrícula (availableTimeLength)
  if (availableTimeLength) {
    return {
      days: differenceInDays(
        new Date().toDateString(),
        addDays(activatedAt, availableTimeLength),
      ),
      expireDate: addDays(activatedAt, availableTimeLength),
    }
  }

  // Prioridade 3: Data do produto (expireDate) - APENAS se não for acesso ilimitado
  // Se availableUntil e availableTimeLength são null, significa acesso ilimitado
  // Neste caso, ignoramos o expireDate do produto
  if (expireDate && (availableUntil !== null || availableTimeLength !== null)) {
    return {
      days: differenceInDays(new Date().toDateString(), expireDate),
      expireDate,
    }
  }

  // Retorna null = acesso ilimitado
  return null
}
